import { CopyIcon } from "@chakra-ui/icons";
import { assertPresence } from "utils/assertions";
import { asyncVoid } from "utils/asyncVoidHandler";
import TooltipIconButton, {
  TooltipIconButtonProps,
} from "components/Shared/TooltipIconButton";

type Props = Omit<TooltipIconButtonProps, "value"> & {
  value: string | null | undefined;
};

export default function CopyButton({ value, isDisabled, ...rest }: Props) {
  return (
    <TooltipIconButton
      icon={<CopyIcon />}
      variant="ghost"
      opacity={0.75}
      isDisabled={!value || !!isDisabled}
      onClick={(e) => {
        e.stopPropagation();
        assertPresence(value, "Expected value to be present");
        asyncVoid(navigator.clipboard.writeText(value));
      }}
      {...rest}
    />
  );
}
